import { API_URL } from '../../../app-config/constants';
import EmailReportSubscription, { EmailReportType } from '../../../types/EmailReportSubscription';
import { get, put, remove } from '../request';

export function getReportSubscription(reportType: EmailReportType) {
    return get<EmailReportSubscription | null>(`${API_URL}/reports/${reportType}`);
}

export function createReportSubscription(subscription: EmailReportSubscription) {
    return put<EmailReportSubscription>(`${API_URL}/reports/${subscription.reportType}`, {
        postData: subscription.configuration,
    });
}

export function deleteReportSubscription(reportType: EmailReportType) {
    return remove(`${API_URL}/reports/${reportType}`);
}
